module.exports = __webpack_public_path__ + "img/food3.d740c5ea.jpg";